/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Actions/ChangeChair/Content/Provider/Content",
  onChange
  
}) {
let providersValueData = fromData.useDataValue({ viewPath,
context: 'providers',
})
let changeChairProviderIdValueData = fromData.useDataValue({ viewPath,
context: 'change_chair',
path: 'provider_id',
})
let changeChairProviderIdChangeData = fromData.useDataChange({ viewPath,
context: 'change_chair',
path: 'provider_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="providers"
 from={providersValueData}
 data="change_chair.provider_id"
 value={changeChairProviderIdValueData}
 onChange={changeChairProviderIdChangeData}
 alignItems="stretch"
 textAlign="left"
 minWidth="100%"
 maxWidth="100%"
 width="100%"
 marginBottom={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Provider"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}